/** Nach der Parteigründung: Schwierigkeitsgrad wählen, dann beginnt der Wahlkampf. */
import { useGame, useS } from '../store/game';
import { CF } from '../content/settings';
import { DiffCards } from './Landing';
import { Illu } from '../components/Illu';

export function DiffPick({ back, openSettings }: { back: () => void; openSettings: () => void }) {
  const S = useS(); const { dispatch } = useGame();
  return (
    <section className="screen">
      <Illu src="/img/szene/wahlkampf.webp" className="illu scene" />
      <div><span className="label">{S.name} · Vor dem Wahlkampf</span><h2>Wie schwer soll es werden?</h2></div>
      <p>Der Schwierigkeitsgrad legt fest, wie oft Krisen kommen, wie empfindlich Verbände, Partei und Gerichte reagieren und wie viel du in der Verwaltung selbst steuerst. Du kannst ihn später in den Einstellungen ändern.</p>
      <DiffCards value={CF().diff} onPick={(k) => dispatch('setDiff', k)} />
      <span className="sub">Einzelne Einflüsse wie Krisen oder das Verfassungsgericht lassen sich auch gezielt an- oder abschalten. <button type="button" className="linkb" onClick={openSettings}>Einflüsse einzeln einstellen</button></span>
      <div className="actions"><button type="button" onClick={back}>Zurück zum Programm</button><button type="button" className="yes" onClick={() => dispatch('campStart')}>Wahlkampf starten</button></div>
    </section>
  );
}
